import HtmlViewerAPI from '@philips-emr/patient-components/src/components/html-viewer/html-viewer-api';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { AlertQuizAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({fragment: FragmentNames.ALERT_QUIZ})
export default class AlertQuizController extends BaseController {

  @OnMount({target: AlertQuizAliases.HTML_VIEWER_ALERT})
  handleMountAlert(event: MountEvent): void {
    const htmlApi = event.target as HtmlViewerAPI;
    htmlApi.setHtmlContent(this.context.get('dsAlert') as string);
  }
}
